@if (hasInputValues()) {
  <div class="mt-8">
    <h2>{{ 'common.info' | actrans }}</h2>
    @if (form().form; as fg) {
      <form nz-form [nzLayout]="'vertical'" [formGroup]="fg">
        <btlib-form-row [controls]="form().controls" [form]="fg" [grid]="{xs: 24, sm: 24, md: 24, lg: 24}" [options]="{}"></btlib-form-row>
      </form>
    }
  </div>
}
